import { NavigateToDocumentReferencePayload } from '../../../../context/EventBusContext/EventBusContext.type';

let pending: NavigateToDocumentReferencePayload | null = null;

export const setPendingNavigation = (payload: NavigateToDocumentReferencePayload) => {
  pending = payload;
};

export const getPendingNavigation = () => pending;

export const clearPendingNavigation = () => {
  pending = null;
};
